import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component GitPullRequestIcon
 * @description
 * Outline git pull-request glyph for source-control signifiers.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string applied to the stroke.
 *
 * @see https://design.activecollab.com/docs/foundations/icons
 */
const GitPullRequestIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="GitPullRequestIcon"
      fill="none"
      stroke={
        gradient
          ? "url(#icon-gradient)"
          : props?.stroke
          ? props.stroke
          : "var(--color-theme-600)"
      }
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M6 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M6 8v8" />
      <path d="M11 6h5a2 2 0 0 1 2 2v8" />
      <path d="M14 9l-3 -3l3 -3" />
    </svg>
  )
);
GitPullRequestIcon.displayName = "GitPullRequestIcon";
export default GitPullRequestIcon;
